import type { GenerationStatus, GenerationTaskSummary } from '@/api/generation';

const RECENT_TERMINAL_TASK_LIMIT = 3;
const ACTIVE_TASK_STATUSES = new Set<GenerationStatus>([
  'created',
  'queued',
  'generating',
  'auditing',
]);

export function isChatTask(task: GenerationTaskSummary): boolean {
  return task.mode === 'text2img' || task.entry_id === 'chat_result';
}

export function isActiveChatTask(task: GenerationTaskSummary): boolean {
  return ACTIVE_TASK_STATUSES.has(task.status);
}

export function selectVisibleChatTasks(
  tasks: GenerationTaskSummary[],
  pinnedIds: Array<string | null | undefined> = [],
  terminalLimit = RECENT_TERMINAL_TASK_LIMIT,
): GenerationTaskSummary[] {
  const pinned = new Set(pinnedIds.filter((id): id is string => !!id));
  const chatTasks = tasks.filter(isChatTask);
  const active = chatTasks.filter(isActiveChatTask);
  const terminal = chatTasks
    .filter((task) => !isActiveChatTask(task))
    .sort((a, b) => b.created_at.localeCompare(a.created_at));
  const selectedTerminal = terminal.filter((task, index) => (
    index < Math.max(0, terminalLimit) || pinned.has(task.gen_id)
  ));
  const byId = new Map<string, GenerationTaskSummary>();
  for (const task of [...active, ...selectedTerminal]) byId.set(task.gen_id, task);
  return Array.from(byId.values()).sort((a, b) => a.created_at.localeCompare(b.created_at));
}
